import { sendEvent } from './sendEvent'

export type TErrorShowKind = 'page_error' | 'white_screen'

const reportedErrors = new WeakSet<object>()

export const sendErrorShowEvent = (kind: TErrorShowKind, message: string, details?: string) => {
    const errorType = `${kind}_${message}`

    sendEvent(
        {
            name: 'error_show',
            payload: details
                ? {
                      params__key: ['error_type', 'error_details'],
                      params__str_value: [errorType, details],
                  }
                : {
                      params__key: ['error_type'],
                      params__str_value: [errorType],
                  },
        },
        true,
    )
}

export const sendErrorShow = (kind: TErrorShowKind, error: unknown, details?: string) => {
    if (typeof error === 'object' && error !== null) {
        if (reportedErrors.has(error)) {
            return
        }

        reportedErrors.add(error)
    }

    sendErrorShowEvent(kind, error instanceof Error ? error.message : String(error), details)
}
